// @noflow
import { dualColorGradiant, OPACITY_LEVEL, TRANSITION_DEF } from '../constants';

import { transparentize } from 'polished';
import { contrastRatioFromColours } from '~/core/utils/colour';
import styled from 'styled-components';

export const Group = styled.g`transition: ${p => (p.isDayDragging ? 'none' : TRANSITION_DEF)};`;

const opacityRect = styled.rect`
    opacity: ${p => ({ [true]: 0.5, [!p.isSelectedDay]: 1, [p.blurEvent]: OPACITY_LEVEL, [p.isSelected]: 1 }[true])};
`;

export const OuterElement = styled(opacityRect)`
    fill: ${p =>
        ({
            [true]: p.valueColor,
            [p.canBeDeleted]: transparentize(0.25, p.valueColor),
            [p.isDualColors]: `url(#${dualColorGradiant})`,
            [p.isCurrentEvent]: p.theme.white
        }[true])};

    stroke: ${p => (p.isDualColors ? `url(#${dualColorGradiant})` : p.valueColor)};
    stroke-dasharray: ${p => (p.dash ? '15 5' : 'inherit')};
    stroke-width: ${p => (p.isTinyEvent ? 1 : 2)};
    transition: ${p => (p.isDayDragging ? 'none' : TRANSITION_DEF)};
`;

export const InnerElement = styled(opacityRect)`
    fill: ${p => (p.isDualColors ? `url(#${dualColorGradiant})` : p.valueColor)};
    stroke: 0;
    transition: ${p => (p.isDayDragging ? 'none' : TRANSITION_DEF)};
`;

export const ClickableArea = styled.rect`
    cursor: ${p => (p.isClickable ? 'pointer' : 'inherit')};
    fill: transparent;
`;

export const Label = styled.text`
    fill: ${p => {
        if (p.textPosition !== 'middle') {
            return p.valueColor;
        }

        // get the contrast ratio between the event colour and the white font
        const contrastRatio = contrastRatioFromColours(p.valueColor, p.theme.white);
        // if the ratio is too low (which means both color are very close) use the main font colour
        return contrastRatio < 2 ? p.theme.fontColor : p.theme.white;
    }};
    font-size: ${p => (p.isCurrentEvent && !p.isDualColors ? '1.05em' : '0.9em')};
    font-weight: ${p => (p.isSelected ? 'bold' : 'inherit')};
    opacity: ${p => (p.hide ? 0 : 1)};
    text-anchor: ${p => p.textPosition};
    transition: ${p => (p.isDayDragging ? 'none' : TRANSITION_DEF)};
`;



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/event/style.js